import React from 'react';
import { ShieldCheckIcon, CreditCardIcon, MailIcon, StarIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-transparent py-8" data-id="element-94">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-95">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-96">
          Elegí tu MegaPack ahora
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-5xl mx-auto mb-6" data-id="element-97">
          <div className="bg-black border border-white/20 rounded-lg p-6 transition-colors shadow-[0_0_15px_rgba(255,255,255,0.1)] hover:shadow-[0_0_25px_rgba(255,255,255,0.2)]" data-id="element-98">
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-99">
              MegaPack Psicopedagogía
            </h3>
            <p className="text-white/70 mb-4 font-['Open_Sans',_sans-serif]" data-id="element-100">
              6 Tomos y 6 Bonos
            </p>
            <div className="mb-6" data-id="element-101">
              <span className="text-white/50 line-through text-lg" data-id="element-102">
                $34.990
              </span>
              <span className="text-white text-3xl font-bold ml-3" data-id="element-103">
                $19.990
              </span>
            </div>
            <a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNB4EpzTs6T2I96cnwo0lLG/es-ar?_r=AQABlPO26gyeESj4cQJvoH3iSTyYf9LIdrgEkMlFx8Bq8fk&cart_link_id=8W8qEKz6&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" className="block w-full bg-white hover:bg-white/90 text-black text-center font-bold text-sm px-4 py-3 rounded-lg transition-all duration-200 hover:scale-105" data-id="element-104">
              🧮→ QUIERO MI MEGAPACK AHORA
            </a>
          </div>
          <div className="bg-[#1A1A1A] border-2 border-[#F5D060] rounded-xl p-6 relative shadow-[0_0_25px_rgba(245,208,96,0.25),0_0_50px_rgba(212,168,67,0.15)] hover:shadow-[0_0_35px_rgba(245,208,96,0.4),0_0_60px_rgba(212,168,67,0.25)] transition-shadow duration-300" data-id="element-105">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-106">
              <div className="bg-gradient-to-r from-[#F5D060] to-[#E8B730] text-[#1A1A1A] px-6 py-2 rounded-full font-bold flex items-center gap-2 shadow-[0_0_15px_rgba(245,208,96,0.4)]" data-id="element-107">
                <StarIcon className="w-5 h-5 fill-current" data-id="element-108" /> ⭐ La Más Elegida
              </div>
            </div>
            <h3 className="text-2xl font-bold text-white mb-2 mt-4" data-id="element-109">
              MegaPack Psicopedagogía +Kit Profesional COMPLETO
            </h3>
            <p className="text-[#D4A843] font-semibold mb-4" data-id="element-110">
              6 Tomos + 6 Bonos + KIT profesional COMPLETO
            </p>
            <div className="mb-6" data-id="element-111">
              <span className="text-white/50 line-through text-lg" data-id="element-112">
                $43.990
              </span>
              <span className="text-[#F5D060] text-3xl font-bold ml-3" data-id="element-113">
                $27.990
              </span>
            </div>
            <a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNB4E9meKkYhBMy6fUynNf0/es-ar?_r=AQABo78Q9twD-D_E4sl-tKmHuDKGH8R9WZS18sN02eg9Ya0&cart_link_id=5PQZWMuB&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#D4A843] hover:bg-[#B8912E] text-white text-center font-bold text-sm px-4 py-3 rounded-lg transition-all duration-200 hover:scale-105 shadow-[0_0_15px_rgba(212,168,67,0.3)]" data-id="element-114">
              → SÍ, QUIERO EL MEGAPACK + KIT PROFESIONAL
            </a>
          </div>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-6 mb-5" data-id="element-115">
          <div className="flex items-center gap-2 text-gray-400" data-id="element-116">
            <ShieldCheckIcon className="w-6 h-6 text-[#D4A843]" data-id="element-117" />
            <span data-id="element-118">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2 text-gray-400" data-id="element-119">
            <CreditCardIcon className="w-6 h-6 text-[#D4A843]" data-id="element-120" />
            <span data-id="element-121">Mercado Pago · Tarjeta · Transferencia</span>
          </div>
        </div>
        <div className="text-center" data-id="element-122">
          <div className="flex items-center justify-center gap-2 text-gray-400" data-id="element-123">
            <MailIcon className="w-5 h-5 text-[#D4A843]" data-id="element-124" />
            <span data-id="element-125">soporte.saludentuplato@gmail.com</span>
          </div>
          <p className="text-gray-500 mt-2" data-id="element-126">
            o por Instagram{' '}
            <a href="https://instagram.com/saludentu.plato" className="text-[#D4A843] font-semibold hover:text-[#E8C55A] hover:underline" data-id="element-127">
              @saludentu.plato
            </a>
          </p>
        </div>
      </div>
    </section>;
}